/* @flow */

import * as React from 'react';
import { observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import Button from '@material-ui/core/Button';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import Loading from 'components/Loading/Loading';

import ActionDrawerHeader from '../../../components/ActionDrawerHeader/ActionDrawerHeader';
import AddNewProductForm from './AddNewProductForm';
import AddNewProductSuccess from './AddNewProductSuccess';
import Form from '../../../../../forms/_.extend';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {|
  formData: Object,
  actionDrawerStore: TypeActionDrawerStore,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class AddNewProduct extends React.Component<*> {
  @observable vModelData = this.props.model;

  createForm = () => {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore }: TypeProps = this.props;
    const parentForm: Object = this.props.parentForm;
    const fields: Array<Object> = [
      {
        name: 'addProductForm',
        label: t('general:actions.new_product'),
        title: 'New Product',
        fields: [
          {
            name: 'tradingAccount',
            label: t('general:trading_account'),
            rules: 'required',
            disabled: Boolean(parentForm.$('chooseAccount.tradingAccount').extra.selectID),
            value: parentForm.$('chooseAccount.tradingAccount').extra.selectID,
          },
          {
            name: 'manufacturer',
            label: t('general:manufacturer'),
            rules: 'required',
            disabled: Boolean(parentForm.$('assetDetail.manufacturer').extra.selectID),
            value: parentForm.$('assetDetail.manufacturer').extra.selectID,
          },
          {
            name: 'manufacturerName',
            label: t('general:manufacturer'),
            rules: 'required',
            disabled: true,
            value: parentForm.$('assetDetail.manufacturer').value,
          },
          {
            name: 'product',
            label: t('general:product'),
            rules: 'required',
            value: '',
          },
          {
            name: 'description',
            label: t('general:description'),
            rules: 'string',
            value: '',
          },
        ],
      },
    ];

    const hooks: Object = {
      onSuccess(data: Object) {
        const {
          tradingAccount,
          manufacturer,
          product,
          description,
        }: Object = data.values().addProductForm;

        actionDrawerStore.userAddProduct({
          account_id: tradingAccount, //parentForm.$('chooseAccount.tradingAccount').value,
          owned_manufacturer_id: manufacturer, //parentForm.$('assetDetail.manufacturer').extra.selectID,
          model: product,
          product_group_description: description,
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        options: {
          validateOnInit: true,
          validateOnChange: true,
        },
        name: 'New Product',
      }
    );
  };

  render(): React.Element<*> {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore }: TypeProps = this.props;
    const parentForm: Object = this.props.parentForm;
    const model: Object = this.props.model;

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={t('general:actions.create_new_product')} />
          <div className={styles['action-drawer-content']}>
            {actionDrawerStore.errorResponse.message}
          </div>
          <div className={styles['action-drawer-actions']}>
            <Button
              color="primary"
              variant="contained"
              onClick={() => actionDrawerStore.closeActionDrawer()}
            >
              {t('general:actions.close')}
            </Button>
          </div>
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <AddNewProductSuccess
          parentForm={parentForm}
          model={this.props.model}
          manufacturerModel={this.props.manufacturerModel}
        />
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={t('general:actions.create_new_product')} />
        <AddNewProductForm
          form={this.createForm()}
          accountsModel={this.props.accountsModel}
          manufacturerModel={this.props.manufacturerModel}
        />
      </div>
    );
  }
}
